import { render, staticRenderFns } from "./FlowSteps.vue?vue&type=template&id=32cff1bc&scoped=true"
import script from "./FlowSteps.vue?vue&type=script&lang=js"
export * from "./FlowSteps.vue?vue&type=script&lang=js"
import style0 from "./FlowSteps.vue?vue&type=style&index=0&id=32cff1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cff1bc",
  null
  
)

export default component.exports